import {
  CRUD_CREATE_SUCCESS,
  CRUD_UPDATE_SUCCESS,
  CRUD_DELETE_SUCCESS,
  Record,
} from "react-admin";
import resourceNames from "../../../data/resourceNames";
import {
  createGroupCreatedAction,
  createGroupUpdatedAction,
  createGroupDeletedAction,
} from "../../actions/appData";
import { GroupDto } from "../../../data/service-proxies";
import { put, takeEvery, all, fork } from "redux-saga/effects";

export function* groupCrudSaga() {
  yield all(
    [onGroupCreateSaga, onGroupUpdateSaga, onGroupDeleteSaga].map(fork)
  );
}

function* onGroupCreateSaga() {
  yield takeEvery(CRUD_CREATE_SUCCESS, handleGroupCreate);
}

function* onGroupUpdateSaga() {
  yield takeEvery(CRUD_UPDATE_SUCCESS, handleGroupUpdate);
}

function* onGroupDeleteSaga() {
  yield takeEvery(CRUD_DELETE_SUCCESS, handleGroupDelete);
}

function* handleGroupCreate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_GROUPS) {
    return;
  }

  const createRequest = action.requestPayload.data as GroupDto;
  const createdGroup = {
    ...createRequest,
    id: action.payload.data.id as number,
  };
  yield put(createGroupCreatedAction(createdGroup));
}

function* handleGroupUpdate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_GROUPS) {
    return;
  }

  const updateRequest = action.payload.data as GroupDto;
  const updatedGroup = {
    ...updateRequest,
  };
  yield put(createGroupUpdatedAction(updatedGroup));
}

function* handleGroupDelete(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { id: number; previousData: Record };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_GROUPS) {
    return;
  }

  yield put(createGroupDeletedAction({ id: action.requestPayload.id }));
}
